<!-- hidden label to calculate if there is a label or not -->
<app-label-inflator #labelCalculator hidden [labelComponentInterface]="data"></app-label-inflator>
<div class="card-content" [style.gap.rem]="viewModel.sidebarAndContentGapInRem$ | async">
  <app-stiiizy-business-side-bar
    *ngIf="viewModel.showSidebar$ | async"
    [cardData]="data"
    [maxWidthInPx]="143"
    [maxHeightInPx]="12">
  </app-stiiizy-business-side-bar>
  <app-stiiizy-business-product-information [cardData]="data"></app-stiiizy-business-product-information>
</div>
